
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[application]",
      function () {
        return require("private-next-pages/[application]/index.js");
      }
    ]);
  